import axios from 'axios';

export function findYards(text) {
    return axios({
        method: 'post',
        url: '/api/v1/yards/find',
        data: {
            query: text,
        },
        withCredentials: true,
    });
}

export function addYard(text) {
    return axios({
        method: 'post',
        url: '/api/vi/yards/save',
        data: {
            query: text,
        },
        withCredentials: true,
    });
}

export function getYardById() {
    return axios({
        method: 'get',
        url: '/api/v1/yards',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/yards.js